import { BaseCssVarValue } from '@/views/game/components/gameCardSuit/components/baseCssVarInject'

/** 外层盒子的css变量 */
export abstract class _OuterBoxBase extends BaseCssVarValue {
  abstract cssType: 'default' | 'larger' | 'small'
  /** 卡片盒子的主体的宽度 */
  '--outer-box-main-width'?: string
  /** 卡片盒子主体的高度 */
  '--outer-box-main-height'?: string
  /** 鼠标悬浮时,上移的高度 (负数) */
  '--hover-move-top-translateY'?: string
}
